<div class="pop-up">
    <h1 mat-dialog-title style="text-align: center; color:blue;">NUEVO REPORTPARAM</h1>
    <div>
        <mat-form-field style="width: 80%;">
            <mat-label>Codigo</mat-label>
            <input matInput type="text " [(ngModel)]="rParam.codigo">
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>Periodo</mat-label>
            <mat-select [(ngModel)]="rParam.periodo" (ngModelChane)="rParam.periodo">
                <mat-option value="HORARIO">HORARIO</mat-option>
                <mat-option value="MENSUAL">MENSUAL</mat-option>
            </mat-select>
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>UndidadT</mat-label>
            <input matInput type="text " [(ngModel)]="rParam.unidadT">
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>UndidadK</mat-label>
            <input matInput type="text " [(ngModel)]="rParam.unidadK">
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="rParam.tipo" (ngModelChane)="rParam.tipo">
                <mat-option value="Gas">Gas</mat-option>
                <mat-option value="Electricidad">Electricidad</mat-option>
                <mat-option value="Agua">Agua</mat-option>
                <mat-option value="Vapor">Vapor</mat-option>
            </mat-select>
        </mat-form-field>
        <br><br>
    </div>
    <div>
        <button class="validar" mat-button mat-button [mat-dialog-close]="null">CARCELAR</button>
        <button class="validar" mat-button mat-button [mat-dialog-close]="rParam" cdkFocusInitial>OK</button>
    </div>
</div>